import { Route, Routes } from 'react-router-dom';
import './App.css';
import WebRoutes from './Routes/WebRoutes';


function App() {
  return (
    <div className="App">
     <Routes>
        <Route path="/*" element={<WebRoutes/>} />
</Routes>
    </div>
  );
}

export default App;
